import { useServices } from '@/hooks';
import googleEn from '@/resources/images/login/google_en.png';
import googleFr from '@/resources/images/login/google_fr.png';
import { Button, ButtonProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

export interface GoogleLoginButtonProps extends ButtonProps {
  small?: true;
}

export const GoogleLoginButton = observer(({ className, small, ...props }: GoogleLoginButtonProps) => {
  const { localization } = useServices();

  const buttonImgSrc = useMemo(() => {
    switch (localization.currentLocale) {
      case 'fr':
        return googleFr;

      case 'en':
      default:
        return googleEn;
    }
  }, [localization.currentLocale]);

  return (
    <Button {...props} className={className} sx={{ ...props.sx, padding: 0, width: 'fit-content' }}>
      <img src={buttonImgSrc} alt="Google Login Button" style={{ width: small ? 180 : 240 }} />
    </Button>
  );
});
